import { createSlice } from '@reduxjs/toolkit';

export enum ThemeEnum {
  light = 'light',
  dark = 'dark',
}

export interface IThemeState {
  currentTheme: ThemeEnum;
}

export const initialState = {
  currentTheme: ThemeEnum.light,
};

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.currentTheme =
        state.currentTheme === ThemeEnum.dark
          ? ThemeEnum.light
          : ThemeEnum.dark;
    },
  },
});

export const { toggleTheme } = themeSlice.actions;

export default themeSlice.reducer;
